<template>
    <div class="SearchList">
        <div class="search">
            <form action="/">
                <van-search v-model="param.key" placeholder="请输入搜索关键词" @search="queryData" show-action
                            @cancel="onCancel"></van-search>
            </form>
        </div>
        <div class="van_box">
            <div class="filter">
                <div class="total">共{{page.rowCount}}份相关报告</div>
                <div class="filterBox">
                    <div class="box" style="width: 100%">
                        <div class="name">发布时间</div>
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="publishDate" :options="option" @change="dateClick"/>
                        </van-dropdown-menu>
                    </div>
                    <div class="box">
                        <div class="name" @click="showPopup">筛选 <img :src="require('@/common/images/report/mobile/screen_icon.png')" alt=""></div>
                        <van-popup v-model="isShow" position="right" :style="{ height: '100%' }">
                            <div class="popup_main">
                                <!--分类-->
                                <div class="popupData_wrap">
                                    <div class="popup_title">
                                        <span>行业分类</span>
                                        <span class="all" @click="allSort">{{isMoreSort ? '收起' : '全部'}}<van-icon :name="isMoreSort?'arrow-up':'arrow-down'" size="0.26rem"/></span>
                                    </div>
                                    <div class="popupData_list sortList_box" :style="{ height : isMoreSort?'auto': scrollHeight+'rem'}">
                                        <div class="popupData_item">
                                            <span :class="{active: param.catecode == ''}" @click="reportSort('')">全部</span>
                                        </div>
                                        <div class="popupData_item" v-for="(item,index) in dataList" :key="index" v-show="item.name">
                                            <span :class="{active: param.catecode == item.code}" @click="reportSort(item.code)">{{item.name}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!--报告类型-->
                                <div class="popupData_wrap">
                                    <div class="popup_title">报告类型</div>
                                    <div class="popupData_list">
                                        <div class="popupData_item" v-for="(item,index) in typeList" :key="index">
                                            <span :class="{active: param.feetype == item.code}" @click="reportType(item.code)">{{item.name}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!--报告年份-->
                                <div class="popupData_wrap">
                                    <div class="popup_title">报告年份</div>
                                    <div class="popupData_list">
                                        <div class="popupData_item" v-for="(item,index) in yearList" :key="index">
                                            <span :class="{active: param.reportyear == item.name}" @click="reportYear(item.name)">{{item.name!=''?item.name+'年':'全部'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--确定按钮-->
                            <div class="popup_footer">
                                <van-button type="default" @click="closePopup">取消</van-button>
                                <van-button type="info" @click="sureSubmit">确定</van-button>
                            </div>
                        </van-popup>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sortList from '../../sort/category/components/sortList.js'; // 分类
    import {mapActions,mapGetters} from 'vuex'
    export default {
        name: "searchList",
        props: ['param', 'page'],
        data(){
            return{
                // 是否展开更多分类
                isMoreSort: false,
                scrollHeight: '4.9',
                isShow: false,
                publishDate: '',
                option: [
                    { text: '正序', value: 1 },
                    { text: '倒序', value: 2 },
                ],
                arr:[],
                dataList:[],
                typeList:[
                    {code:'',name:'全部'},
                    {code:'1',name:'免费'},
                    {code:'2',name:'收费'},
                    {code:'3',name:'会员'}
                ],
                yearList:[
                    {name:''},
                    { name:'2020'},
                    {name:'2019'},
                    {name:'2018'},
                    {name:'2017'},
                    {name:'2016'}
                ]
            }
        },
        mounted() {
            this.dataList = sortList
        },
        methods: {
            // 打开筛选弹窗
            showPopup(){
                this.isShow = true;
            },
            // 关闭筛选弹窗
            closePopup(){
                this.isShow = false;
            },
            // 发布时间
            dateClick(){
                this.param.reportyeartype = this.publishDate
                this.$emit('getList')
                this.setRefresh(true);
            },
            queryData() {
                this.$emit('getList')
            },
            onCancel() {
                this.$router.push({name: 'MReportIndex'});
            },
            // 展开全部行业
            allSort(){
              this.isMoreSort= !this.isMoreSort;
              this.scrollHeight = this.isMoreSort ? 'auto' : '4.9';
            },
            // 报告分类
            reportSort(code){
                this.param.catecode = code
            },
            // 报告类型
            reportType(code){
                this.param.feetype = code
            },
            // 报告年份
            reportYear(code){
                this.param.reportyear = code
            },
            // 确定提交
            sureSubmit(){
                this.isShow = false;
                console.log(this.param)
                this.$emit('getList')
                this.setRefresh(true);
            },
            ...mapActions(['setRefresh'])
        },
        activated() {
            if(this.refresh){
                this.$emit('getList');
                this.setRefresh(false)
            }
        },
        filters: {},
        computed: {
            ...mapGetters(['refresh'])
        },
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .SearchList {
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        background: $c-white;
        z-index: 1;
        .search{
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            height: 0.88rem;
            font-size: 0.28rem;
            border-bottom: 0.01rem solid $line;
            .van-search{
                padding: 0;
                height: 0.58rem;
                line-height: 0.58rem;
                .van-search__content{
                    padding-left: 0;
                    border-radius: 0.29rem;
                    overflow: hidden;
                }
                .van-search__action{
                    padding-left:0.4rem;
                    padding-right: 0;
                    color: $c-blue;
                }
                .van-cell{
                    background: #F5F5F5;
                    padding: 0.05rem 0.16rem 0.05rem 0;
                }
                .van-field__left-icon{
                    margin-left: 0.24rem;
                }
            }
        }
        .filter{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.32rem;
            font-size: 0.26rem;
            .van-ellipsis{
                color: #999;
                font-size: 0.24rem;
            }
            .total,.name{
                color: $c-grey;
                line-height: 0.4rem;
            }
            .filterBox{
                width: 3.5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .box{
                    width: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .name{
                        display: flex;
                        align-items: center;
                        img{
                            width: 0.25rem;
                            height: 0.24rem;
                            margin-left: 0.08rem;
                        }
                    }
                    .van-dropdown-menu__title{
                        color: #999;
                    }
                    /*弹出框样式start*/
                    .van-popup{
                        .popup_main{
                            height: 92%;
                            overflow-y: scroll;
                            .popupData_wrap{
                                .popup_title{
                                    display: flex;
                                    justify-content: space-between;
                                    font-size: 0.28rem;
                                    color: #333;
                                    margin: 0.28rem 0.32rem;
                                    .all{
                                        font-size: 0.24rem;
                                        color: #999;
                                        display: flex;
                                        i{
                                            margin-left: 0.05rem;
                                        }
                                    }
                                }
                                .popupData_list{
                                    display: flex;
                                    flex-flow: row wrap;
                                    justify-content: space-between;
                                    padding: 0 0.18rem;
                                    .popupData_item{
                                        span{
                                            width:1.76rem;
                                            height:0.70rem;
                                            line-height: 0.7rem;
                                            text-align: center;
                                            font-size: 0.28rem;
                                            color: #999;
                                            background:rgba(255,255,255,1);
                                            border:0.01rem solid #e5e5e5;
                                            margin: 0.13rem;
                                            display: inline-block;
                                        }
                                        .active{
                                            width:1.76rem;
                                            height:0.70rem;
                                            display: inline-block;
                                            border:0.01rem solid rgba(64,158,255,1);
                                            color: #409EFF;
                                            background: url('../../../../common/images/report/mobile/select_icon.png') no-repeat top right;
                                            background-size: 0.4rem 0.4rem;
                                        }
                                    }
                                }
                                .sortList_box{
                                    /*height: 4.9rem;*/
                                    overflow: hidden;
                                }
                            }
                        }
                        .popup_footer{
                            width: 100%;
                            height: 1rem;
                            position: fixed;
                            bottom: 0;
                            background: #fff;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .van-button{
                                width:2.78rem;
                                height:0.70rem;
                                line-height: 0.7rem;
                                border-radius:0.38rem;
                                margin: 0 0.15rem;
                            }
                            .van-button--default{
                                color: #999;
                            }
                        }
                    }
                    /*弹出框样式end*/
                }
                .box+.box{
                    border-left: 0.01rem solid $line;
                    padding-left: 0.12rem;
                    margin-left: 0.24rem;
                }
            }
        }
        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
            border-width: 0;
        }
        .slide-sort-enter-active, .slide-sort-leave-active{
            transition: all 0.5s
        }
        .slide-sort-enter, .slide-sort-leave-to{
            transform: translate3d(100%, 0, 0)
        }
    }
    /*弹出框样式*/
    .van-popup--right{
        width: 6.48rem;
    }
</style>